module.exports = __webpack_public_path__ + "static/media/5_MACDONALDS.f8082462.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_mcdonalds/5_MACDONALDS.jpg
// module id = 1166
// module chunks = 37